import React, { useMemo } from 'react';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { LottiePlayer } from '@shared/components';
import { useTranslation } from '@shared/core';
import { VerticalScrollMessages } from '@shared/components/VerticalScrollMessages';
import { JoyAiV2 } from '@withjoy/joykit/icons';

const LOADER_ANIMATION_ICON = 'https://withjoy.com/assets/public/apps/travel/lotties/accom-console-loader-texts.json ';

export const AccommodationsConsoleLoader = () => {
  const { tq } = useTranslation('accommodationsConsole');

  const messages = useMemo(() => {
    return [
      tq`Loading all hotels around your event`,
      tq`Finding the best hotels near the venue`,
      tq`Selecting hotels loved by Joy guests`,
      tq`Unlocking your exclusive Joy rates`,
      tq`Calculating walk and drive time`,
    ];
  }, [tq]);

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      maxWidth={pxToRem(388)}
      width="100%"
      height="100%"
    >
      <Box
        maxWidth={pxToRem(150)}
        maxHeight={pxToRem(150)}
      >
        <LottiePlayer
          play={true}
          loop
          lottieUrl={LOADER_ANIMATION_ICON}
        />
      </Box>
      <TextV2
        typographyVariant={'hed6'}
        textAlign={'center'}
      >
        {tq`Finding hotels with exclusive event rates, up to 40% off.`}
      </TextV2>
      <Flex width="100%">
        <Flex
          alignItems={'center'}
          marginTop={9}
          gap={4}
        >
          <JoyAiV2 size={32} />
          <VerticalScrollMessages
            messages={messages}
            height={pxToRem(240)}
            shouldPauseOnMessage={true}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
